module.exports = __webpack_public_path__ + "static/media/secietypic01@3x.34b5e584.png";